module.exports = __webpack_public_path__ + "static/media/robloxOrderLine.e441a187.jpg";